export default __webpack_public_path__ + "static/nested-grid-light-6b030322497dfc969debff7af001e6c8.png";